import { Tag, type TableColumnsType } from 'antd';
import { CatalogueRowActions } from './CatalogueRowActions';
import type { TruckClass } from './reference-data.api';

interface BuildTruckClassColumnsArgs {
  onEdit: (row: TruckClass) => void;
  onDeactivate: (row: TruckClass) => Promise<void>;
  onReactivate: (row: TruckClass) => Promise<void>;
}

export function buildTruckClassColumns({ onEdit, onDeactivate, onReactivate }: BuildTruckClassColumnsArgs): TableColumnsType<TruckClass> {
  return [
    { title: 'Code', dataIndex: 'code', key: 'code', render: (code: string) => <span className="font-mono text-xs">{code}</span> },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Typical capacity (t)', dataIndex: 'typicalCapacityTonnes', key: 'typicalCapacityTonnes' },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => <Tag color={isActive ? 'success' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, row) => <CatalogueRowActions row={row} onEdit={onEdit} onDeactivate={onDeactivate} onReactivate={onReactivate} />,
    },
  ];
}
